
import React from "react";
import {
    BrowserRouter as Router,
    useNavigate
} from "react-router-dom";

export default function Results({ preview, filename, results }) {
    const navigate = useNavigate();
    let noofres = 0;
    if (results && results.length > 0) {
        noofres = results.length;
    }
    const viewresult = () => {
        navigate("/list" + window.location.search)
    }
    return (
        <div className="container-fluid" onClick={() => viewresult()}>
            <div className="upload_imege_div">
                <div className="uploadimage_div">
                    {/* <input type="file" /> */}
                    <img src={preview} alt="" />
                </div>
                <img src="/assets/images/circle.svg" className="d-block mx-auto img_dot" alt="" />
                <h5>{filename}</h5>
                <h6>{noofres}</h6>
            </div>
        </div>
    )
}